import {createContext} from "react";

export const WMSContext = createContext({
    currentMemberAuthorizations: null,
    currentMember: null,
    currentInventory: null,
    currentOrganization: null,
    preferredPrinter: {},
    preferredPackingStation: {},
    currentTask: null,
    setPreferredPackingStation: (container) => {},
    setCurrentTask: (task) => {},
    groupWmsItemsBySku: (wmsItems) => {},
    redirect: (path) => {}
})
